const priceFormat = new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" });

export function formatMoney(amount: number): string {
  return priceFormat.format(amount);
}

// The admin-only half — storefront-ui's copy of this file never needed a
// parser, since it never lets a visitor type a price. These validate a
// price-edit form's raw input before it round-trips to catalog-service, and
// must match PriceUpdateService.MaxUnitPrice / Router.MaxReorderPoint
// exactly (no shared package between services, so a server-side change to
// either constant needs a matching edit here).

/**
 * >0, <1,000,000, at most 2 decimal places — or null if invalid. Validated
 * against the raw string shape (not `n * 100` arithmetic) to sidestep
 * floating-point rounding on values like 19.99.
 */
export function parsePrice(input: string): number | null {
  const trimmed = input.trim();
  if (!/^\d+(\.\d{1,2})?$/.test(trimmed)) return null;
  const n = Number(trimmed);
  return n > 0 && n < 1_000_000 ? n : null;
}

/** A non-negative integer, <1,000,000 — or null if invalid. */
export function parseReorderPoint(input: string): number | null {
  const trimmed = input.trim();
  if (!/^\d+$/.test(trimmed)) return null;
  const n = Number(trimmed);
  return n < 1_000_000 ? n : null;
}
